import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { MeheIngestionStats } from '../../_models/mehe-ingestion-stats';

@Injectable({
  providedIn: 'root'
})
export class MeheService {

  constructor(private httpClient: HttpClient) { }

  public getMeheIngestionStats(): Observable<MeheIngestionStats[]> {
    return this.httpClient.get<MeheIngestionStats[]>(environment.API_BASE_URL + "measurement/getMeheIngestionStats");
  }
}
